exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".serviceHomeComponent .nav-item>a[data-v-34cf8676]{text-decoration:none;color:grey;font-size:1rem}\n", ""]);

